import axios from "axios";
import api from "../api/apiClient";
import { baseURL } from "../env/env";


const authService = {
  login: async (username, token) => {
    try {
      const response = await axios.post(`${baseURL}/user/login/`, { username, token });
      return response.data;
    } catch (error) {
      console.error("Error in login:", error);
      throw error;
    }
  },

  updateDomain: async (userid, restricted, partial, role, superuser) => {
    try {
      const response = await api.put("update-domain/", {
        userid,
        restricted: superuser ? false : restricted,
        partial: superuser ? false : partial,
        role: role == null ? "editor" : role,
      });

      return response.data;
    } catch (error) {
      console.error("Error in login:", error);
      throw error;
    }
  },
};

export default authService;
